import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('TextContainer')(css({
    maxWidth: '300px',
    margin: ['0', '0px 0px 0px 30px'],
    width: ['100%', '65%'],
}));
themeStyles.addBaseStyles('GraphicContainer')(css({
    margin: ['0', '0px 0px 0px 30px'],
}));
themeStyles.addBaseStyles('ItemContainer')(css({
    display: 'flex',
    padding: ['20px 10px 0px 10px!important', '20px 0px 20px 0px!important', '20px 0px 0px 0px!important'],
    flexDirection: ['column', 'row'],
    alignItems: ['flex-start', 'center'],
}));
themeStyles.addBaseStyles('StaticNumberContainer')(css({
    display: 'flex',
    justifyContent: ['flex-start', 'flex-end'],
    width: ['100%', '160px'],
}));
themeStyles.addBaseStyles('ValueTextContainer')(css({
    display: 'flex',
    justifyContent: ['flex-start', 'flex-end'],
    alignItems: 'center',
    width: '160px',
    marginBottom: ['10px', 0],
}));
themeStyles.addBaseStyles('ValueText')(({ theme }) => css({
    fontWeight: '500',
    fontStyle: 'normal',
    fontSize: ['44px', '50px'],
    lineHeight: ['50px', '60px'],
    color: theme.colors.red,
    fontFamily: 'default',
    textAlign: 'right',
    height: '60px',
}));
themeStyles.addBaseStyles('BodyTextContainer')(css({
    my: ['xs', 'm'],
    p: {
        mb: ['default'],
    },
    h6: {
        mb: ['4px'],
        color: ['blue'],
    },
}));
export default themeStyles;
